type UndoToastProps = {
  visible: boolean;
  message: string;
  onUndo: () => void;
};

export default function UndoToast({
  visible,
  message,
  onUndo,
}: UndoToastProps) {
  if (!visible) {
    return null;
  }

  return (
    <div className="undo-toast">
      <span>{message}</span>

      <button
        type="button"
        onClick={onUndo}
      >
        Desfazer
      </button>
    </div>
  );
}